import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { withRouter } from '../../utils/hoc/withRouter';

class Reports extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() { }

    render() {
        return (
            <div>Reports Component </div>
        )
    }
}

const mapStateToProps = state => ({
    reportsState: state.ReportsState
});
const mapDispatchToProps = {
    // getPosts: fetchPosts
}
Reports.propTypes = {
    // getPosts: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Reports));